import React, { Component } from "react";
import moment from "moment";
import { isCallService } from "../../common/scripts/services";
import Mensajes from "../../common/scripts/mensajes";

export default class AddContactos extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      contactos: [],
      parentesco: [],
      executed: false,
      disabled: true,
      showModal: false,
      error: false,
      visibleSelectorParentesco: false,
      visibleSelectorDocumento: false,
    };
    this.removeContacto = this.removeContacto.bind(this);
    this.addContacto = this.addContacto.bind(this);
    this.removeThisContacto = this.removeThisContacto.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleId = this.handleId.bind(this);
    this.handleParentesco = this.handleParentesco.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.contactos = [];
  }

  componentDidMount() {
    let parentesco = i18next.t("table.parentescoList").split(",");
    this.setState({ parentesco });
  }

  componentWillReceiveProps(props) {
    if (
      props.submitInfo === "submit" &&
      this.state.contactos.length > 0 &&
      !this.state.executed
    ) {
      this.handleSubmit();
      this.setState({ executed: true });
    }
  }

  getPlanContacto() {
    event.preventDefault();
    let data = {
      TipoDocumento: this.props.documentSelected.CSIdDocumentoText,
      NumeroDocumento: this.props.numeroDocumento,
      // "Opcion": "34",
      // "TiempoCache": 1440,
      // "FiltrarGrupoFamiliar": false
      TiempoCache: 120,
    };
    isCallService({
      // loadingElement: '',
      service: "ObtenerRiesgosUsuario",
      params: data,
      changeState: "planContactoPrincipal",
      executeCallback: (result) => {
        let plan = "";
        result.CodigoPlan.length > 0
          ? result.CodigoPlan[0] !== null
            ? result.CodigoPlan.map((item) => {
                plan = plan + item + ",";
              })
            : null
          : null;
        this.setState({ planContactoPrincipal: plan });
      },
      error: "error",
      condition: true,
      showLogs: false,
      mainObject: this,
    });
  }

  removeContacto(event) {
    event.preventDefault();
    let newContactos = this.state.contactos;
    newContactos.pop();
    this.setState({ contactos: newContactos }, () => this.validateFormTable());
  }

  addContacto(event) {
    event.preventDefault();
    let newState = this.state.contactos;
    let contacto = {
      nombre: null,
      tipoId: "Selecciona tu documento",
      numId: null,
      parentesco: "Selecciona el parentezco",
      ciudad: null,
      direccion: null,
      telefono: null,
      fechaDeContacto: null,
      respuestaServicioObtenerRiesgos: false,
    };
    if (newState.length < 20) {
      let newContacto = newState.concat(contacto);
      this.setState({ contactos: newContacto }, () => this.validateFormTable());
    }
  }

  removeThisContacto(event, index, item) {
    event.preventDefault();
    let newContactos = this.state.contactos;
    let contactosFiltered = newContactos.filter((element) => element != item);
    this.setState({ contactos: [] }, () => {
      this.setState({ contactos: contactosFiltered }, () =>
        this.validateFormTable()
      );
    });
  }

  handleChange(event, index) {
    let contacto = this.state.contactos[index];
    contacto[event.target.name] = event.target.value;
    if (event.target.name === "numId" && event.target.value.length >= 7) {
      isCallService({
        // loadingElement: '',
        service: "ObtenerRiesgosUsuario",
        params: {
          TipoDocumento: this.state.contactos[index].documentId,
          NumeroDocumento: event.target.value,
          //   Opcion: "34",
          //   TiempoCache: 1440,
          TiempoCache: 120,
        },
        changeState: "codigoPlan",
        executeCallback: (result) => {
          let plan = "";
          if (result != null) {
            result.CodigoPlan.length > 0
              ? result.CodigoPlan[0] !== null
                ? result.CodigoPlan.map((item) => {
                    plan = plan + item + ",";
                  })
                : null
              : null;
            contacto.ciudadServicio = result.Ciudad;
            contacto.codigoCiudad = result.CodigoCiudad;
            contacto.plan = plan;
            contacto.Observaciones = result.Observaciones;
          } else {
            contacto.Observaciones =
              "falla en el servicio de ObtenerRiesgosUsuario";
          }
          contacto.respuestaServicioObtenerRiesgos = true;
          let newState = this.state.contactos;
          newState[index] = contacto;
          this.setState({ contactos: newState }, () =>
            this.validateFormTable()
          );
        },
        error: "error",
        condition: true,
        showLogs: false,
        mainObject: this,
      });
    }
    let newState = this.state.contactos;
    newState[index] = contacto;
    this.setState({ contactos: newState }, () => this.validateFormTable());
  }

  handleId(documento, index) {
    let contacto = this.state.contactos[index];
    contacto.tipoId = documento.CSDocumentoIdentidadText;
    contacto.documentId = documento.CSIdDocumentoText;
    let newState = this.state.contactos;
    newState[index] = contacto;
    this.setState({ contactos: newState });
  }

  handleParentesco(parentesco, index) {
    let contacto = this.state.contactos[index];
    contacto.parentesco = parentesco;
    let newState = this.state.contactos;
    newState[index] = contacto;
    this.setState({ contactos: newState });
  }

  handleSubmit() {
    let plan = "";
    this.props.plan.length > 0
      ? this.props.plan[0] !== null
        ? this.props.plan.map((item) => {
            plan = plan + item + ",";
          })
        : null
      : null;
    let acumulador = 0;
    this.state.contactos.map((contacto) => {
      let data = {
        Accion: "ADD",
        Lista: "TemasCovid19-ReporteContactos",
        UrlSitio: window.location.origin + "/salud/transacciones",
        Campos: {
          Valores: [
            { NombreInternoCampo: "NombreUsuario", Valor: this.props.nombre },
            { NombreInternoCampo: "TipoDocumento", Valor: this.props.tipoId },
            {
              NombreInternoCampo: "NumeroDocumento",
              Valor: this.props.numeroDocumento,
            },
            // { "NombreInternoCampo": "CiudadUsuario", "Valor": this.props.ciudad },
            { NombreInternoCampo: "NombreContacto", Valor: contacto.nombre },
            { NombreInternoCampo: "TipoIdContacto", Valor: contacto.tipoId },
            { NombreInternoCampo: "NumeroIdContacto", Valor: contacto.numId },
            { NombreInternoCampo: "Parentesco", Valor: contacto.parentesco },
            { NombreInternoCampo: "Ciudad", Valor: contacto.ciudad },
            { NombreInternoCampo: "Direccion", Valor: contacto.direccion },
            { NombreInternoCampo: "Telefono", Valor: contacto.telefono },
            {
              NombreInternoCampo: "FechaDeContacto",
              Valor: contacto.fechaDeContacto,
            },
            {
              NombreInternoCampo: "NombreCiudadRegistrada",
              Valor: contacto.ciudadServicio,
            },
            {
              NombreInternoCampo: "CodigoPlanDeContacto",
              Valor: contacto.plan,
            },
            {
              NombreInternoCampo: "CodigoCiudadRegistrada",
              Valor: contacto.codigoCiudad,
            },
            { NombreInternoCampo: "PlanContactoPrincipal", Valor: plan },
            {
              NombreInternoCampo: "Observaciones",
              Valor: contacto.Observaciones,
            },
          ],
        },
      };
      isCallService({
        // loadingElement: '',
        service: "UtilidadSharepoint",
        params: data,
        changeState: "usuarioExiste",
        executeCallback: (result) => {
          acumulador = acumulador + 1;
          acumulador === this.state.contactos.length
            ? this.setState({ showModal: true })
            : null;
        },
        error: "error",
        condition: true,
        showLogs: false,
        mainObject: this,
      });
    });
  }

  validateFormTable() {
    let tableForm = null;
    let validation = this.state.contactos.map((contacto) => {
      let serviceValidation =
        contacto["numId"] == null
          ? true
          : contacto["respuestaServicioObtenerRiesgos"] == true;
      if (
        contacto["nombre"] == "" ||
        contacto["nombre"] == null ||
        contacto["telefono"] == null ||
        contacto["telefono"] == "" ||
        contacto["ciudad"] == null ||
        contacto["ciudad"] == "" ||
        contacto["fechaDeContacto"] == null ||
        !serviceValidation
      ) {
        tableForm = true;
      } else {
        tableForm = false;
      }
    });
    validation;
    this.setState({ disabled: tableForm }, () =>
      this.props.tableValidated(tableForm)
    );
  }

  render() {
    let idList;
    [idList] = [this.props.documentos];
    return (
      <section>
        <div
          dangerouslySetInnerHTML={this.props.handleGenericHtml(
            i18next.t("table.subtitleComponent")
          )}
        />
        {/* <h4>{i18next.t("table.subtitle")}</h4> */}

        <div className="form-group row">
          <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
            {i18next.t("forms.contactos")}
          </label>
          <div className="col-sm-8">
            <label className="form-quantity">
              {this.state.contactos.length}
            </label>
            <div className="form-controls">
              <button
                className="form-controls-action remove"
                onClick={(event) => this.removeContacto(event)}
              >
                -
              </button>
              <button
                className="form-controls-action add"
                onClick={(event) => this.addContacto(event)}
              >
                +
              </button>
            </div>
          </div>
        </div>

        <hr></hr>

        <div className="table-responsive table-responsive--height">
          <table className="historicoTable table table-hover table-bordered">
            <thead>
              <tr>
                <th className="historicoTable--title"></th>
                <th width="20%" className="historicoTable--title">
                  {i18next.t("table.nombre")}
                </th>
                <th width="20%" className="historicoTable--title">
                  {i18next.t("table.telefono")}
                </th>
                <th className="historicoTable--title">
                  {i18next.t("table.parentesco")}
                </th>
                <th width="18%" className="historicoTable--title">
                  {i18next.t("table.tipoId")}
                </th>
                <th className="historicoTable--title">
                  {i18next.t("table.numId")}
                </th>
                <th width="20%" className="historicoTable--title">
                  {i18next.t("table.ciudad")}
                </th>
                <th width="20%" className="historicoTable--title">
                  {i18next.t("table.direccion")}
                </th>
                <th className="historicoTable--title">
                  {i18next.t("table.fechaDeContacto")}
                </th>
                <th width="9%" className="historicoTable--title"></th>
              </tr>
            </thead>
            <tbody>
              {this.state.contactos.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        key={index.toString()}
                        type="text"
                        className={
                          "form-control formularioSolicitud--input formularioSolicitud--input-width "
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.nombre}
                        name="nombre"
                      />
                    </td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          "form-control formularioSolicitud--input formularioSolicitud--input-width "
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.telefono}
                        name="telefono"
                      />
                    </td>
                    <td>
                      <div className="dropdown">
                        <button
                          style={{ cursor: "pointer" }}
                          className="dropdown-toggle formularioSolicitud--dropDown"
                          // type="button"
                          id="dropdownParentezco"
                          // data-toggle="dropdown"
                          // aria-haspopup="true"
                          // aria-expanded="true"
                          onClick={() =>
                            this.setState({
                              visibleSelectorParentesco:
                                !this.state.visibleSelectorParentesco,
                            })
                          }
                        >
                          <div>
                            <p className="text-left">{item.parentesco}</p>
                          </div>
                          <span className="caret"></span>
                          <ul
                            className="dropdown-menu formularioSolicitud--dropDown-contactos"
                            style={{
                              cursor: "pointer",
                              display: `${
                                this.state.visibleSelectorParentesco
                                  ? "block "
                                  : "none"
                              }`,
                            }}
                          >
                            {this.state.parentesco.map((element, position) => {
                              return (
                                <li
                                  key={position}
                                  onClick={() => {
                                    this.setState({
                                      visibleSelectorParentesco: false,
                                    });
                                    this.handleParentesco(element, index);
                                  }}
                                >
                                  <p>{element}</p>
                                </li>
                              );
                            })}
                          </ul>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="dropdown-toggle formularioSolicitud--dropDown"
                          // type="button"
                          id="dropdownCedula"
                          // data-toggle="dropdown"
                          // aria-haspopup="true"
                          // aria-expanded="true"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.setState({
                              visibleSelectorDocumento:
                                !this.state.visibleSelectorDocumento,
                            })
                          }
                        >
                          <div>
                            <p className="text-left">{item.tipoId}</p>
                          </div>
                          <span className="caret"></span>
                          <ul
                            className="dropdown-menu formularioSolicitud--dropDown-contactos"
                            style={{
                              cursor: "pointer",
                              display: `${
                                this.state.visibleSelectorDocumento
                                  ? "block "
                                  : "none"
                              }`,
                            }}
                          >
                            {idList.map((element, position) => {
                              return (
                                <li
                                  key={position}
                                  onClick={() => {
                                    this.setState({
                                      visibleSelectorDocumento: false,
                                    });
                                    this.handleId(element, index);
                                  }}
                                >
                                  <p>{element.CSDocumentoIdentidadText}</p>
                                </li>
                              );
                            })}
                          </ul>
                        </button>
                      </div>
                    </td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          "form-control formularioSolicitud--input formularioSolicitud--input-width "
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.numId}
                        name="numId"
                      />
                    </td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          "form-control formularioSolicitud--input formularioSolicitud--input-width "
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.ciudad}
                        name="ciudad"
                      />
                    </td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          "form-control formularioSolicitud--input formularioSolicitud--input-width "
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.barrio}
                        name="direccion"
                      />
                    </td>
                    <td>
                      <input
                        style={{ cursor: "pointer" }}
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        className={
                          "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                        }
                        onChange={(event) => this.handleChange(event, index)}
                        value={item.fechaDeContacto}
                        name="fechaDeContacto"
                      />
                    </td>
                    <td>
                      <button
                        className="btn btn-default"
                        onClick={(event) =>
                          this.removeThisContacto(event, index, item)
                        }
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    );
  }
}
